import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export const Portrait = ({ testId, className = "", alt = "Portrait of Sheetal Garg, founder and guide of Panchmaya" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);

  return (
    <div ref={ref} data-testid={testId} className={`arch relative aspect-[4/5] w-full overflow-hidden border border-[#e4dacb] bg-[#efe6d8] ${className}`}>
      <motion.img
        style={{ y, scale: 1.1 }}
        src="/sheetal-garg.webp"
        srcSet="/sheetal-garg-320.webp 320w, /sheetal-garg.webp 638w"
        sizes="(min-width: 1024px) 440px, (min-width: 768px) 40vw, 384px"
        width="638"
        height="797"
        loading="lazy"
        decoding="async"
        alt={alt}
        className="absolute inset-0 h-full w-full object-cover object-[60%_20%]"
      />
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_110%,rgba(212,166,74,0.22),transparent_60%)]" />
      <img src="/panchmaya-mark-112.webp" width="48" height="48" loading="lazy" alt="" className="absolute bottom-5 left-5 h-12 w-12 rounded-full shadow-[0_8px_30px_rgba(34,30,27,0.35)]" />
    </div>
  );
};
